import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-12 copyright">
              <div className="social-links">
                <a href="https://twitter.com/?lang=en" target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-twitter"></i>
                </a>
                <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-facebook-f"></i>
                </a>
                <a href="https://www.instagram.com/?hl=en" target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-instagram"></i>
                </a>
                <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-youtube"></i>
                </a>
              </div>
              <div className="footer-links">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/terms-and-conditions">Terms and Conditions</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="after-footer">
        <div className="container">
          <div className="row gx-lg-5">
            <div className="col-12">
              <p className="text-center">Copyright © {new Date().getFullYear()} bluetidesolutions | All rights reserved Copyright</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;